import { withUnauth } from '~/hocs/with-unauth'
import { DonorPortalSignIn } from '~/pages/donor-portal/pages/sign-in'

export default withUnauth(DonorPortalSignIn, { type: 'donor-portal' })
